<template>
<main>
  <header>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/hotel' }">酒店</el-breadcrumb-item>
      <el-breadcrumb-item>酒店列表</el-breadcrumb-item>
    </el-breadcrumb>
    <hotelSearch :hasKeyWrod="true" :hasHotelType="false" :param="search" class="search" @change="changeSearch"/>
  </header>
  <ul class="list" v-loading="loading">
    <li v-for="v in list" :key="v.HotelID">
      <img :src="v.ImageUrl" :alt="v.HotelName">
      <div class="info">
        <h3>{{ v.HotelName | getHotelName(0) }}</h3>
        <h4>{{ v.HotelName | getHotelName(1) }}</h4>
        <p>联系方式：{{v.Telephone}}</p>
        <p>地址：{{v.Address_CN}}</p>
        <div class="price">
          <b>{{v.LowestPrice.Value}}</b>
          <el-button type="primary" @click="toDetail(v)"><span>查看可订选项</span><i class="icon-you"></i></el-button>
        </div>
      </div>
    </li>
  </ul>
  <el-pagination
    background
    layout="prev, pager, next"
    @current-change="changePage"
    :hide-on-single-page="true"
    :total="total">
  </el-pagination>
</main>
</template>

<script>
import hotelSearch from '@components/hotel_search';
export default {
  components: {
    hotelSearch
  },
  data () {
    return {
      search: {},
      loading: true,
      total: 0,
      info: {
        page: 1,
        rows: 12,
      },
      list: []
    }
  },
  created () {
    const { data } = this.$route.query;
    const params = JSON.parse(data);
    this.search = { ...params, cityObj: params.city, city: params.city.CityName_CN };
    this.getList();
  },
  filters: {
    getHotelName (val, i) {
      const [ cn, en ] = val.split('(');
      switch (i) {
        case 0: 
          return cn;
        case 1: 
          return en.split(')')[0];
      }
    }
  },
  methods: {
    toDetail (v) {
      const { time: [ CheckInDate, CheckOutDate ], minor, adult } = this.search;
      const { HotelID } = v;
      const data = {
        HotelID,
        CheckInDate,
        CheckOutDate,
        ChildCount: minor,
        AdultCount: adult
      };
      this.$router.push({ name: 'hotel_detail', query: data });
    },
    changeSearch (data) {
      this.search = { ...data, cityObj: data.city };
      this.info = { ...this.info, page: 1 };
      this.getList();
    },
    changePage (page) {
      this.info = { ...this.info, page };
      this.getList();
    },
    async getList (param) {
      this.loading = true;
      const params = this.getRequestData(param);
      const { Success: { PriceDetails: { HotelList: list, FilterList: { Pagination: { TotalCount } } } } } = await this.$axios.get('/didaApi/searchHotel', { params });
      this.list = list;
      this.total = TotalCount;
      this.loading = false;
      window.scrollTo({top: 0, behavior: "smooth"});
    },
    getRequestData (param) {
      const { keyword, minor, adult, time: [ CheckInDate, CheckOutDate ], cityObj: { CityCode } } = param || this.search;
      const { page, rows } = this.info;
      return {
        page, rows, CheckInDate, CheckOutDate,
        PersonCount: minor + adult,
        ChildCount: minor,
        AdultCount: adult,
        HotelKeyWord: keyword,
        CityCode: CityCode
      }
    }
  }
}
</script>

<style scoped src="./list.css"></style>